// platform.js — lightweight client platform / OS detection helpers

/**
 * Detect whether we are running on iOS / iPadOS.
 * Mirrors the logic used in stores/camelraceAssets.js so behaviour stays consistent.
 */
export function isIOS() {
    if (typeof navigator === 'undefined') return false
    const ua = navigator.userAgent || ''

    // Standard iOS user agents (iPhone, iPod, iPad, Chrome on iOS)
    const isIOSUserAgent = /(iPad|iPhone|iPod)/i.test(ua)

    // iPadOS "desktop" Safari reports a Mac UA but exposes touch
    const isMacTouch =
        ua.includes('Mac') && typeof document !== 'undefined' && 'ontouchend' in document

    return isIOSUserAgent || isMacTouch
}

/**
 * Parse the iOS / iPadOS version from the user agent.
 * Returns { major, minor, patch } or null when it can't be determined
 * (e.g. iPadOS desktop-mode, which omits the OS version from the UA).
 */
export function getIOSVersion() {
    if (typeof navigator === 'undefined') return null

    const match = (navigator.userAgent || '').match(/OS (\d+)_(\d+)(?:_(\d+))?/i)
    if (!match) return null

    return {
        major: parseInt(match[1], 10),
        minor: parseInt(match[2], 10),
        patch: match[3] ? parseInt(match[3], 10) : 0,
    }
}

/**
 * Camel Race requires iOS 18.4 or later. iOS 18.0–18.3 ship a WebKit
 * regression that breaks the game, so those versions are blocked.
 *
 * Returns false when not on iOS or when the version can't be determined,
 * so we never block a device we're unsure about.
 */
export function isCamelRaceUnsupportedIOS() {
    if (!isIOS()) return false

    const version = getIOSVersion()
    if (!version) return false

    return version.major === 18 && version.minor >= 0 && version.minor <= 3
}
